import { render } from "./StreamsManage.vue?vue&type=template&id=5558cee4&scoped=true"
import script from "./StreamsManage.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManage.vue?vue&type=script&setup=true&lang=js"

import "./StreamsManage.vue?vue&type=style&index=0&id=5558cee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5558cee4"],['__file',"src/views/StreamsDash/StreamsManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5558cee4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5558cee4', __exports__)) {
    api.reload('5558cee4', __exports__)
  }
  
  module.hot.accept("./StreamsManage.vue?vue&type=template&id=5558cee4&scoped=true", () => {
    api.rerender('5558cee4', render)
  })

}


export default __exports__